import API from "../../../../../app/api";

export const getBlogListing = async (slug) => {
  try {
    const res = await API.get(`/blogs`);
    if (res.data.status === 200) {
      return res.data.data;
    }
    throw new Error(res.data.message || "Failed to fetch blog");
  } catch (err) {
    console.error("Error fetching blog:", err);
    throw err;
  }
};
